import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Footer from '@/components/Footer';

function Section({ title, children }) {
  return (
    <div className="space-y-2">
      <h2 className="font-heading font-bold text-base text-[#48293A]">{title}</h2>
      <div className="text-sm text-[#4C4D57] leading-relaxed space-y-2">{children}</div>
    </div>
  );
}

export default function AvisoLegalPage() {
  return (
    <div className="min-h-screen bg-[#FBF8F3] flex flex-col">
      <div className="flex-1 max-w-2xl mx-auto w-full px-4 py-8 space-y-7">
        <div className="flex items-center gap-3">
          <Link to="/" className="p-2 rounded-full hover:bg-[#48293A]/8 transition-colors text-[#48293A]">
            <ChevronLeft size={20} />
          </Link>
          <img src="/logo.png" alt="El Club de Manri" className="h-8 w-auto" />
        </div>

        <h1 className="font-heading font-bold text-2xl text-[#48293A]">Aviso Legal</h1>

        <Section title="1. Datos identificativos">
          <p>
            En cumplimiento de la Ley 34/2002 (LSSI-CE), se informa de que <strong>El Club de Manri</strong> es
            un sitio web y aplicación operados por:
          </p>
          <ul className="list-none space-y-1">
            <li><strong>Titular:</strong> 18 Innovación Educativa, S.L.</li>
            <li><strong>CIF:</strong> B70848882</li>
            <li><strong>Domicilio:</strong> Calle Los Calados, Edificio Alondras, 1, 38111 Santa Cruz de Tenerife</li>
            <li><strong>Correo electrónico:</strong> info@elclubdemanri.es</li>
          </ul>
        </Section>

        <Section title="2. Objeto">
          <p>
            El Club de Manri tiene por objeto la gestión de inscripciones y la participación de menores en
            las actividades de ocio y animación infantil organizadas en el Parque Marítimo César Manrique
            (Santa Cruz de Tenerife).
          </p>
        </Section>

        <Section title="3. Condiciones de uso">
          <p>
            El acceso a la aplicación y el registro de una familia implican la aceptación de este Aviso Legal
            y de la Política de Privacidad. El usuario se compromete a facilitar información veraz y a hacer
            un uso adecuado de la plataforma. El registro de menores debe realizarlo el padre, madre o tutor/a legal.
          </p>
        </Section>

        <Section title="4. Propiedad intelectual e industrial">
          <p>
            Los contenidos, la marca "El Club de Manri", el logotipo y los elementos gráficos están protegidos
            y son titularidad de su operador o se utilizan con autorización. Queda prohibida su reproducción
            o uso sin consentimiento.
          </p>
        </Section>

        <Section title="5. Responsabilidad">
          <p>
            Se procura el correcto funcionamiento del servicio, pero no se garantiza la ausencia de
            interrupciones o errores. No se responde de los daños derivados de un uso inadecuado de la
            plataforma por parte de los usuarios.
          </p>
        </Section>

        <Section title="6. Protección de datos">
          <p>
            El tratamiento de los datos personales se rige por la{' '}
            <Link to="/privacidad" className="text-[#48293A] underline font-medium">
              Política de Privacidad
            </Link>{' '}
            de El Club de Manri, que forma parte de este Aviso Legal.
          </p>
        </Section>

        <Section title="7. Legislación aplicable">
          <p>
            Este Aviso Legal se rige por la legislación española. Para cualquier controversia, las partes
            se someten a los juzgados y tribunales que correspondan conforme a la normativa aplicable.
          </p>
        </Section>
      </div>

      <Footer />
    </div>
  );
}
